import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../css/project.css';

export default function Project() {

    const [showMore, setShowMore] = useState(false);

    const toggleCertificates = () => {
        setShowMore(prev => !prev);
    };

    // Smooth Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.15,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const itemVariants = {
        hidden: {
            opacity: 0,
            y: 40,
            scale: 0.96
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const titleVariants = {
        hidden: { opacity: 0, y: -30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.7,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    return (
        <>
            {/* PROJECT SECTION */}
            <section className="projects-section">
                <motion.h2
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={titleVariants}
                >
                    My Projects
                </motion.h2>

                <motion.div
                    className="project"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={containerVariants}
                >
                    <motion.div className="project-item" variants={itemVariants}>
                        <div className="project-date">2025</div>
                        <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                        <div className="project-content">
                            <h3>ClickNBuild</h3>
                            <p className="project-name">Web App – Construction Platform</p>
                            <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                            <p>
                                A web platform developed using Flask that connects clients with builders and vendors, streamlining construction project coordination and procurement.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div className="project-item" variants={itemVariants}>
                        <div className="project-date">2025</div>
                        <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                        <div className="project-content">
                            <h3>Zeval</h3>
                            <p className="project-name">Real Estate Price Estimator</p>
                            <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                            <p>
                                Developed a house cost prediction system using data from Zameen.com. Implemented data cleaning, unit conversions, and ML models like Random Forest and Decision Tree with 80%+ accuracy.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div className="project-item" variants={itemVariants}>
                        <div className="project-date">2024</div>
                        <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                        <div className="project-content">
                            <h3>Flex</h3>
                            <p className="project-name">Student-Teacher Portal</p>
                            <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                            <p>
                                A web-based system to facilitate communication and data sharing between students and faculty. Includes features like attendance tracking, grading, and messaging.
                            </p>
                        </div>
                    </motion.div>

                    {showMore && (
                        <>
                            <motion.div
                                className="project-item"
                                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: -30, scale: 0.95 }}
                                transition={{ duration: 0.4 }}
                            >
                                <div className="project-date">2023</div>
                                <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                                <div className="project-content">
                                    <h3>RideMate</h3>
                                    <p className="project-name">SRS – Cab Booking App</p>
                                    <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                                    <p>
                                        Wrote a complete Software Requirements Specification for a cab booking app, including system models, use case diagrams, and detailed functional requirements.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div
                                className="project-item"
                                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.4, delay: 0.1 }}
                            >
                                <div className="project-date">2023</div>
                                <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                                <div className="project-content">
                                    <h3>Bank Management System</h3>
                                    <p className="project-name">C++ Console Application</p>
                                    <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                                    <p>
                                        Developed a banking system using object-oriented programming in C++. Features include account creation, transaction handling, and statement generation.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div
                                className="project-item"
                                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.4, delay: 0.2 }}
                            >
                                <div className="project-date">2022</div>
                                <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                                <div className="project-content">
                                    <h3>Tic-Tac-Toe Game</h3>
                                    <p className="project-name">C Console Game</p>
                                    <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                                    <p>
                                        A two-player console game built using C, implementing clean game logic and a user-friendly UI.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div
                                className="project-item"
                                initial={{ opacity: 0, y: 30, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.4, delay: 0.3 }}
                            >
                                <div className="project-date">2022</div>
                                <div className="project-icon"><img src="/images/idea.png" alt="" /></div>
                                <div className="project-content">
                                    <h3>Hangman Game</h3>
                                    <p className="project-name">Python Console Game</p>
                                    <p style={{ fontSize: 'smaller', marginTop: 0 }}><strong>Description</strong></p>
                                    <p>
                                        A word-guessing game built in Python featuring input validation, hints, and visual indicators for remaining attempts.
                                    </p>
                                </div>
                            </motion.div>
                        </>
                    )}
                </motion.div>

                {/* Show More Button */}
                <motion.div
                    style={{ textAlign: 'center', marginTop: '1.5rem' }}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5 }}
                >
                    <motion.button
                        onClick={toggleCertificates}
                        id="showMoreBtn"
                        className="showmore-btn"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        {showMore ? 'Show Less' : 'Show More'}
                    </motion.button>
                </motion.div>
            </section>
        </>
    );
}
